import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
    const navigate = useNavigate(); // For React Router v6+

    const handleLogout = () => {
        // Clear user data from local storage/session storage
        localStorage.removeItem('authToken');
        localStorage.removeItem('userUUID');
        localStorage.removeItem('BusinessID');
        console.error("sdhncjgjdgcbjboixgs");
        // Optionally, call a logout API endpoint if needed
        // Example:
        // fetch('http://yourapi.com/logout', { method: 'POST' });

        // Redirect to login page
        navigate('/login'); // Navigate to the login page
    };

    // Call handleLogout when this component is mounted
    React.useEffect(() => {
        handleLogout();
    }, []); // Empty dependency array ensures this runs only once

    return null; // Render nothing, as this component is only for logout
};

export default Logout;
